import React, { Component } from 'react'
import { Alert, Form, Icon, Input } from 'antd'
import { infoRequired, validateCep } from '../../../utils/validators';
import { request } from '../../../utils/api';
import {
    maskCepOnChange as maskCep
} from '../../../utils/masks'

import cep from 'cep-promise'

function fillEndereco(e){
    cep(e.target.value).then(data => {
        let cidade = data.city
        let estado = data.state
        let endereco = data.street

        document.getElementById('signup-form_estado').innerHTML = estado
        document.getElementById('signup-form_cidade').innerHTML = cidade
        document.getElementById('signup-form_endereco').innerHTML = endereco
        
    }).catch(err => {
        // console.log(err)
    })
}

class FormEndereco extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: null,
            message: '',
            success: false
        }
    }

    componentWillMount() {
        if (this.interval) {
            clearTimeout(this.interval)
        }
    }

    handleSuccess = () => {
        this.setState({
            success: true,
            loading: false,
            message: ''
        }, () => {
            this.interval = setTimeout(() => {
                this.setState({
                    success: false
                })
            }, 6000)
        })
    }

    handleSubmit = e => {
        e.preventDefault()
        this.props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                this.setState({
                    loading: true
                })
                try {
                    let cidade = ''
                    let estado = ''
                    let endereco = ''
                    cep(values.cep).then(async data => {
                        cidade = data.city
                        estado = data.state
                        endereco = data.street

                        const response = await request('users/add-address', 'PUT', {
                            id: this.props.user.id,
                            ...values,
                            cidade,
                            estado,
                            endereco
                        })
                        if (response.code === 200) {
                            this.handleSuccess()
                        } else {
                            this.setState({
                                loading: false,
                                message: response.message || 'Ops! Não conseguimos cadastrar seu endereço no momento!'
                            })
                        }
                    }).catch(async err => {
                        const response = await request('users/add-address', 'PUT', {
                            id: this.props.user.id,
                            ...values,
                            cidade,
                            estado,
                            endereco
                        })
                        if (response.code === 200) {
                            this.handleSuccess()
                        } else {
                            this.setState({
                                loading: false,
                                message: response.message || 'Ops! Não conseguimos cadastrar seu endereço no momento!'
                            })
                        }
                    })
                } catch(e) {
                    this.setState({
                        loading: false,
                        message: 'Ops! Não conseguimos cadastrar seu endereço no momento!'
                    })
                }
            }
        })
    }

    render() {
        const { form } = this.props
        return this.state.success ? (
            <div className="senhaSuccess animated bounceInRight">
                <div>
                    <Icon type="check-circle" />
                </div>
                <div>
                    <h2>Endereço cadastrado!</h2>
                </div>
            </div>
        ) : (
            <div className="animated fadeIn">
                <Form layout="vertical" onSubmit={this.handleSubmit}>
                    {this.state.message && <Form.Item>
                        <Alert message={this.state.message} type="error" showIcon />
                    </Form.Item>}

                    <div style={{ textAlign: 'center' }}>
                        {this.state.loading && <Form.Item>
                            <Icon type="loading" />
                        </Form.Item>}
                    </div>

                    <Form.Item label="CEP (ao preencher o CEP, as informações de endereço serão atualizadas automaticamente)">
                    {form.getFieldDecorator('cep', {
                        rules: [
                            infoRequired,
                            validateCep()
                        ]
                    })(
                        <Input type="text" placeholder="CEP"  onChange={fillEndereco} onKeyPress={maskCep}/>
                    )}
                </Form.Item>

                <Form.Item label="Estado">
                    <label id="signup-form_estado"></label>
                </Form.Item>

                <Form.Item label="Cidade">
                    <label id="signup-form_cidade"></label>
                </Form.Item>

                <Form.Item label="Endereço">
                    <label id="signup-form_endereco"></label>
                </Form.Item>

                <Form.Item label="Número">
                    {form.getFieldDecorator('numero', {
                        rules: [
                            infoRequired,
                        ]
                    })(
                        <Input type="text" placeholder="Número" />
                    )}
                </Form.Item>

                <Form.Item label="Complemento">
                    {form.getFieldDecorator('complemento', {
                        
                    })(
                        <Input type="text" placeholder="Complemento" />
                    )}
                </Form.Item> 

                    <Form.Item>
                        <button type="submit" className="alterarSenhaSubmit">
                            Enviar
                        </button>
                    </Form.Item>
                </Form>
            </div>
        )
    }
}

export default Form.create({ name: 'endereco' })(FormEndereco)